import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Loader from './Loader';
import { useProfileContext } from '../providers/ProfileProvider';
import { useCandidateContext } from '../providers/CandidateProvider';

const ProtectedRoute = ({ children }) => {
  const { profile, loading } = useProfileContext();
  const navigate = useNavigate();
  const location = useLocation();
  const { candidate, loading: candidateLoading, isAdmin } = useCandidateContext();

  useEffect(() => {
    if (loading) return;
    if (isAdmin) {
      if (location.pathname === '/onboarding') {
        navigate('/');
      }
      return;
    }
    if (candidateLoading) return;

    const isProfileComplete = profile &&
      profile.secondaryEmail &&
      profile.phoneNumber &&
      profile.gender &&
      profile.dateOfBirth &&
      profile.country &&
      candidate &&
      candidate.seniority &&
      candidate.primaryRole &&
      candidate.linkedIn;

    if (location.pathname === '/onboarding') {
      if (isProfileComplete) {
        navigate('/');
      }
      return;
    }

    if (profile && !isProfileComplete) {
      navigate('/onboarding');
    }
  }, [profile, loading, navigate, location.pathname, isAdmin, candidate, candidateLoading]);

  if (loading || (!isAdmin && candidateLoading)) {
    return <Loader />;
  }

  return children;
};

export default ProtectedRoute;